import { Divider } from "@mui/material";
import CoreSpinner from "../../../../../../app/core/components/CoreSpinner/CoreSpinner";

const ServiceTenant = ({
  group = [],
  services = [],
  filterService = [],
  loading,
}) => {
  if (loading) {
    return <CoreSpinner />;
  }

  return (
    <div>
      {/* Sezione per i servizi individuali - qui mostro la lista fornita */}
      {services
        .filter((service) => service.isForAll === true)
        .map((el, idx) => (
          <>
            <div
              className="flex py-5 items-center space-x-16"
              key={`service-${idx}`}
            >
              <div className="flex w-24 h-24 items-center">
                <img
                  alt="Immagine"
                  src={el.iconUrl || "/img/placeholder-image.svg"}
                  style={{
                    maxWidth: "90px",
                    maxHeight: "90px",
                  }}
                />
              </div>
              <div className="w-6/12">
                <h3 className="m-0">{el.name}</h3>
                <p className="m-0">{el.description}</p>
              </div>
            </div>
            <Divider />
          </>
        ))}

      {/* Sezione filterService originale */}
      {filterService.map((el, idx) => (
        <>
          <div
            className="flex py-5 items-center space-x-16"
            key={`filter-service-${idx}`}
          >
            <div className="flex w-24 h-24 items-center">
              <img
                alt="Immagine"
                src={el.iconUrl || "/img/placeholder-image.svg"}
                style={{
                  maxWidth: "90px",
                  maxHeight: "90px",
                }}
              />
            </div>
            <div className="w-6/12">
              <h3 className="m-0">{el.name}</h3>
              <p className="m-0">{el.description}</p>
            </div>
          </div>
          <Divider />
        </>
      ))}
    </div>
  );
};

export default ServiceTenant;
